import React from 'react';
import { Phone, MapPin, Calendar } from 'lucide-react';
import { Button } from './ui/button';
import { contactInfo } from '../data/mock';

export const HeroSection = () => {
  const handleCall = () => {
    window.location.href = `tel:${contactInfo.phones[0]}`;
  };

  const handleDirections = () => {
    window.open('https://maps.google.com/?q=Raj+Canine+Care+Vadodara', '_blank');
  };

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleBookAppointment = () => {
    window.open('https://2026.geteasysoftware.com/raj_cannine/qr/index.php?branch_id=UzN4eE9JUEUzaUltOERvTTJKVVNGUT09', '_blank');
  };

  return (
    <section 
      id="home" 
      className="pt-20 relative min-h-[600px] md:min-h-screen"
    >
      {/* Mobile Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat md:hidden"
        style={{ backgroundImage: "url('/images/mobilehero.jpg')" }}
      ></div>
      
      {/* Desktop Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat hidden md:block"
        style={{ backgroundImage: "url('/images/hero.jpg')" }}
      ></div>
      
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-black/50"></div>
      
      <div className="container mx-auto px-4 py-20 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-block px-4 py-2 bg-blue-400/90 rounded-full mb-6">
            <span className="text-gray-900 font-medium text-sm"> VETERINARY CLINIC • GROOMING STUDIO • PET SHOP </span>
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Raj Canine Care
          </h1>
          <p className="!font-medium !text-2xl mb-4 text-white">Complete Care for Dogs & Cats 

          </p>
          <p className="text-lg text-gray-100 mb-8">
            Compassionate veterinary care, professional grooming, and premium pet products — all under one roof. Your pet's happiness is our priority! 🐾
          </p>

          {/* Stats Badge */}
          <div className="inline-block mb-8">
            <div className="bg-gradient-to-r from-blue-600/90 to-blue-700/90 text-white px-8 py-4 rounded-2xl shadow-lg backdrop-blur-sm">
              <p className="text-sm font-medium mb-1">Proud to have served</p>
              <p className="text-4xl font-bold">10,000+ Pets 🐾</p>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-12 justify-center">
            <Button
              onClick={handleCall}
              size="lg"
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg">

              <Phone className="w-5 h-5 mr-2" />
              Call Now
            </Button>
            <Button
              onClick={handleDirections}
              size="lg"
              className="bg-white hover:bg-gray-100 text-blue-600 px-8 py-6 text-lg">

              <MapPin className="w-5 h-5 mr-2" />
              Get Directions
            </Button>
            <Button
              onClick={handleBookAppointment}
              size="lg"
              className="bg-yellow-500 hover:bg-yellow-600 text-white px-8 py-6 text-lg">

              <Calendar className="w-5 h-5 mr-2" />
              Book Appointment
            </Button>
          </div>

          {/* Quick Highlights */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
            <div className="flex flex-col items-center space-y-2 p-4 bg-white/95 backdrop-blur-sm rounded-xl shadow-md">
              <span className="text-3xl">🩺</span>
              <p className="text-gray-700 text-sm text-center font-medium">Experienced Veterinary Care</p>
            </div>
            <div className="flex flex-col items-center space-y-2 p-4 bg-white/95 backdrop-blur-sm rounded-xl shadow-md">
              <span className="text-3xl">✨</span>
              <p className="text-gray-700 text-sm text-center font-medium">Hygienic Grooming Studio</p>
            </div>
            <div className="flex flex-col items-center space-y-2 p-4 bg-white/95 backdrop-blur-sm rounded-xl shadow-md">
              <span className="text-3xl">🐕</span>
              <p className="text-gray-700 text-sm text-center font-medium">Dog & Cat Specialization</p>
            </div>
            <div className="flex flex-col items-center space-y-2 p-4 bg-white/95 backdrop-blur-sm rounded-xl shadow-md">
              <span className="text-3xl">🛍️</span>
              <p className="text-gray-700 text-sm text-center font-medium">Quality Pet Food & Accessories</p>
            </div>
          </div>
        </div>
      </div>
    </section>);

};